// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"519":"df1bd17d","787":"909b9ed9","812":"77f1fe33","994":"5509e7f6"}[chunkId] + ".chunk.js";
};